// getTopAndBottomPopupNotificationContentSize.js
'use strict';

import toEven from '../resource/toEven.js';
import { getIsOnMobileBySize } from '../resource/getUserAgent.js';
import {
  popupNotificationTopAndBottomMaximumWidth,
  popupNotificationTopAndBottomMaximumWidthInDesktop,
  popupNotificationTopAndBottomHeight,
  popupNotificationTopAndBottomHorizontalPadding,
} from '../style/variables.js';

const isServer = typeof window === 'undefined';

/**
 * @typedef Size
 * @property {number} width - content width.
 * @property {number} height - content height.
 */

/**
 * Get top and bottom popup notification content size.
 * @param {number} {[deviceWidth = 0]} - device width.
 * @param {number} {[deviceHeight = 0]} - device height.
 * @return {Size} content size.
 */
const getTopAndBottomPopupNotificationContentSize = ({
  deviceWidth = 0,
  deviceHeight = 0,
} = {}) => {
  const isMobile = getIsOnMobileBySize();
  const size = {
    width: 0,
    height: popupNotificationTopAndBottomHeight,
  };

  if (isServer || [deviceWidth, deviceHeight].includes(0)) {
    return size;
  }

  const contentWidth = Math.min(
    deviceWidth - popupNotificationTopAndBottomHorizontalPadding * 2,
    isMobile
      ? popupNotificationTopAndBottomMaximumWidth
      : popupNotificationTopAndBottomMaximumWidthInDesktop
  );

  size.width = toEven({ value: contentWidth });

  return size;
};

export default getTopAndBottomPopupNotificationContentSize;
